<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card-title class="px-0">Commissions</v-card-title>
      </v-col>
    </v-row>
    <v-row justify="end" v-if="!readonly">
      <v-col cols="12" sm="6" lg="4" xl="3">
        <v-btn block outlined color="primary" @click="addCommission">
          Add Commission
          <v-icon right>add</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="showCommissionRow" class="mt-10 mb-0">
      <v-col cols="12">
        <CommissionInput
          v-bind:is="commissionComponent"
          v-for="commission in commissionsValue"
          :key="commission.id"
          :commissionInput="commission"
          :userSessionId="userId"
          :readonly="readonly"
          :validCommissionPercentages="validCommissionPercentages"
          @commissionRowChange="handleCommissionRowChange"
          @commissionChange="handleCommissionChange"
          @remove="handleRemoveCommission"
        ></CommissionInput>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-alert
          v-if="!readonly && !validCommissionPercentages && commissionsValue && commissionsValue.length > 0"
          :value="true"
          color="error"
          icon="report"
        >
          Commissions percentages must equal to 100% when added up
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import guid from '@/lib/guid'
import { CommissionInput } from '@/components/commissions'
import { SimplePageHeader } from '@/components/pageComponents'
import { getTotalCommisions } from '@/lib/commissions'

export default {
  components: {
    CommissionInput,
    SimplePageHeader
  },
  props: [
    'commissionComponent',
    'commissionType',
    'commissions',
    'userId',
    'readonly'
  ],
  data () {
    return {
      commissionFormat: {
        commission: {
          id: null,
          commission: 0,
          userId: null,
          role: null
        },
        userCommission: {
          id: null,
          userId: null,
          minAmount: 0,
          maxAmount: 0,
          commissionPercent: 0
        }
      },
      validCommissionPercentages: true
    }
  },
  computed: {
    commissionsValue: {
      get () {
        return this.commissions
      },
      set (newValue) {
        this.$emit('commissionsChange', newValue)
      }
    },
    showCommissionRow: {
      get () {
        return this.commissionsValue.length > 0
      }
    }
  },
  methods: {
    getNewCommission () {
      let newCommission = Object.assign({}, this.commissionFormat[this.commissionType])
      newCommission.id = guid()
      newCommission.userId = this.userId
      return newCommission
    },
    handleCommissionChange () {
      this.validCommissionPercentages = getTotalCommisions(this.commissionsValue)
    },
    handleCommissionRowChange (newCommissionValue) {
      this.commissionsValue = newCommissionValue
      if (this.commissionsValue && this.commissionsValue.length > 1) {
        this.validCommissionPercentages = getTotalCommisions(this.commissionsValue)
      }
      this.$emit('commissionsChange', this.commissionsValue)
    },
    addCommission () {
      this.commissionsValue.push(this.getNewCommission())
    },
    handleRemoveCommission (id) {
      let index = this.getIndexCommissionById(id)
      this.commissionsValue.splice(index, 1)
      if (this.commissionsValue.length > 0) {
        this.validCommissionPercentages = getTotalCommisions(this.commissionsValue)
      } else {
        this.validCommissionPercentages = true
      }
    },
    validateCommissionsPercentages () {
      if (this.commissionsValue && this.commissionsValue.length > 0 && !this.readonly) {
        this.validCommissionPercentages = getTotalCommisions(this.commissionsValue)
      } else {
        this.validCommissionPercentages = true
      }
      return this.validCommissionPercentages
    },
    getIndexCommissionById (id) {
      return this.commissionsValue.findIndex(x => x.id === id)
    }
  }
}
</script>
